export default __webpack_public_path__ + "images/a16495a1aeb61f9f69c48d96784c2c6a.svg";